import { POST_EMPTY_DRAFT_REPORT_SUCCESS } from './';

export default payload => dispatch =>
  dispatch({
    type: POST_EMPTY_DRAFT_REPORT_SUCCESS,
    payload,
  });
